/**
 * Phone chrome for the custom color picker — a bottom sheet, the column's
 * idiom for the desktop modal. `design/GT Mobile Crew.dc.html` `ccShow`;
 * DESIGN-CHANGELOG 2026-08-18. Capped at 92vh with the sticky header (field +
 * legend + readout overflow a short phone viewport). The body is
 * `components/CustomColorBody.tsx`, shared with the desktop modal.
 * Registered in `store/history.ts` (kind `cc`).
 */

import { CustomColorBody } from '../components/CustomColorBody.tsx';
import { Sheet } from '../components/Sheet.tsx';
import { useQd } from '../store/index.ts';

export default function CustomColorSheet(): JSX.Element {
  const s = useQd();
  return (
    <Sheet
      label="Custom color picker"
      maxHeight="92vh"
      onClose={s.closeCc}
      header={{
        title: 'CUSTOM COLOR',
        titleClr: 'var(--gt-text)',
        titleFs: '8px',
        note: 'HUE × LIGHTNESS',
        extra: (
          <span style={{ fontFamily: 'var(--gt-font-mono)', fontSize: '9px', color: 'var(--gt-muted-2)', flex: 'none' }}>
            TAP THE FIELD
          </span>
        ),
      }}
    >
      <CustomColorBody />
    </Sheet>
  );
}
